import { useState, useEffect } from 'react';

import { validateEmail } from '../../../../lib/validate';
import analyticsTrack from '../../../../lib/analytics/analyticsTrack';

interface IUseConversionEmailHarvester {
  insploreTopic?: string;
  boardId?: string | number;
  vendorVariantId?: string | number;
  vendorProductGroupName?: string;
}

export default function useConversionEmailHarvester({
  insploreTopic,
  boardId,
  vendorVariantId,
  vendorProductGroupName
}:IUseConversionEmailHarvester): {
  email: string;
  isValid: boolean | null;
  submitted: boolean;
  setEmail: (email: string) => void;
  onSubmit: (e: any) => void;
} {
  const [email, setEmail] = useState('');
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const onSubmit = (e: any) => {
    e.preventDefault();
    const validEmailPattern = validateEmail(email);
    if (validEmailPattern) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }

    setSubmitted(true);
    analyticsTrack('email_subscribe', {
      email,
      validEmailPattern,
      referrerUrl: window.location.href,
      insploreTopic,
      boardId,
      vendorVariantId,
      vendorProductGroupName
    });
  };

  useEffect(() => {
    if (isValid === false) {
      setIsValid(null);
    }
  }, [email]);

  return {
    email,
    isValid,
    submitted,
    setEmail,
    onSubmit
  };
}
